import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import SearchDebitNotes from './components/SearchDebitNote';

const DebitNotes = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 style={{ marginBottom: 30 }}>Información notas debito de cartera</h3>
      </Col>
    </Row>
    <Row>
        <SearchDebitNotes />
    </Row>
  </Container>
);

export default DebitNotes;